module.exports = __webpack_public_path__ + "static/img/7.de96870.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/service/imgs/7.png
// module id = TfN7
// module chunks = 1